import React from "react";

const OpenFullScreenIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 960 960"
      width="40"
      height="40"
      fill="none"
      stroke="#fff"
      strokeWidth="40"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path strokeWidth="80" d="M100 360 L100 240 L260 240" />
      <path strokeWidth="80" d="M860 360 L860 240 L700 240" />
      <path strokeWidth="80" d="M100 640 L100 760 L260 760" />
      <path strokeWidth="80" d="M860 640 L860 760 L700 760" />
    </svg>
  );
};

export default OpenFullScreenIcon;
